import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getSelectedBusinessTaxRates } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Arrays from "utils/Arrays";
import AutoCompleteInput from "nlib/ui/AutoCompleteInput";
import Badge from "nlib/ui/Badge";
import Constants from "const/Constants";
import Objects from "utils/Objects";
import React, { useCallback, useMemo, useState } from "react";

const SelectTaxRateInput = (props) => {
  const { uiTexts } = useSelector(getTextsData);

  const {
    value = {},
    validate,
    placeholder = uiTexts.selectTaxRate,
    onChange,
    ...restProps
  } = props;

  const [showAll, setShowAll] = useState(false);

  const { name: nameValue = "" } = value;

  const taxRates = useSelector(getSelectedBusinessTaxRates);

  const items = useMemo(() => {
    return [...taxRates]
      .sort(({ name: nameA }, { name: nameB }) => nameA.localeCompare(nameB))
      .map(({ id, name }) => ({ value: id, label: name }));
  }, [taxRates]);

  const filteredItems = useMemo(() => {
    if (!nameValue || showAll) return items;

    const localValue = nameValue.trim().toLowerCase();

    return items.filter((item) => {
      if (!item.label) return false;

      const itemValue = item.label.trim().toLowerCase();

      if (itemValue === localValue || itemValue.includes(localValue)) {
        return true;
      }

      return Objects.checkSimilarityBy(
        { value: nameValue },
        { value: item.label },
        Constants.DATA_SIMILARITY_COEFFICIENT
      );
    });
  }, [nameValue, showAll, items]);

  const renderLabel = useCallback(({ label }) => {
    return (
      <div className={Css.listItem} title={label}>
        <span className={Css.name}>{label}</span>
        <Badge className={Css.badge}>{uiTexts.taxRate}</Badge>
      </div>
    );
  }, [uiTexts]);

  const handleChange = useCallback((newName) => {
    onChange({ name: newName });
  }, [onChange]);

  const handleAutoComplete = useCallback((item) => {
    onChange(Arrays.findById(taxRates, item.value));
  }, [taxRates, onChange]);

  return (
    <AutoCompleteInput
      {...restProps}
      iconBefore={Icons.Percent}
      placeholder={placeholder}
      iconBeforeTitle={uiTexts.vat}
      value={nameValue}
      showAll={showAll}
      renderLabel={renderLabel}
      items={items}
      filteredItems={filteredItems}
      onSetShowAll={setShowAll}
      onChange={handleChange}
      onAutoComplete={handleAutoComplete} />
  );
};

export default React.memo(SelectTaxRateInput);
